/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import './ShareCardBottomBar.styles.scss';

import { Grid } from '../../../components/Grid';

interface Props {
  cssColor?: string;
}
const ShareCardBottomBar: React.FC<Props> = (props) => (
  <div className="cmp-sharecard-bottombar" style={{ backgroundColor: props.cssColor }}>
    <Grid justifyContent="space-between" alignItems="center" height="74px" flexWrap="nowrap">
      {props.children}
    </Grid>
  </div>
);

export default ShareCardBottomBar;
